export default __webpack_public_path__ + "static/media/ebay-icon.1e0ffa33.svg";